import { cn } from "@/lib/utils";
import { Chip, ChipProps, CircularProgress } from "@nextui-org/react";
import React from "react";
import LottieAnimation from "../LottieAnimation";
import getAnimation from "@/common/function/getAnimation";
export type ButtonStatus = "normal" | "disabled" | "loading" | "processing" | "error" | "success";
type ChipButtonProps = {
  buttonType?: string;
  status: ButtonStatus;
} & ChipProps;
function ChipButton({
  children,
  classNames,
  color,
  variant,
  onClick,
  as,
  buttonType,
  isDisabled,
  status,
  radius
}: ChipButtonProps) {
  return <Chip type={buttonType} isDisabled={isDisabled} as={as} radius={radius} onClick={onClick} color={color} variant={variant} classNames={{
    base: cn("px-2 pt-[5px] pb-1", classNames?.base),
    content: cn("px-0 text-[13px] leading-[1.2]", classNames?.content)
  }} data-sentry-element="Chip" data-sentry-component="ChipButton" data-sentry-source-file="index.tsx">
      {status === "normal" && children}
      {status != "normal" && <div className="flex items-center gap-2 justify-center">
          {status == "loading" && <CircularProgress aria-label="Loading..." color="secondary" classNames={{
        svg: "w-4 h-4"
      }} />}
          {status == "success" && <LottieAnimation src={getAnimation("success_button")} loop={false} autoplay={true} className="w-4 h-4" />}
          {status == "error" && <LottieAnimation src={getAnimation("error_button")} loop={false} autoplay={true} className="w-4 h-4" />}
        </div>}
    </Chip>;
}
export default ChipButton;